/* eslint-disable react-hooks/exhaustive-deps */
import { Pagination, Table, Tag } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../../assets/Images/icons/icon-back';
import MyTaskService from '../../../services/MyTask.service';

export default function History() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    let { state, historyId } = useParams();
    const [historyInfo, setHistoryInfo] = useState([]);

    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });

    useEffect(() => {
        getHistoryDetail();
    }, [historyId]);

    const getHistoryDetail = async (pageValue) => {
        // console.log(pageValue)
        try {
            const { data } = await MyTaskService.getHistoryDetail({
                dsrTaskHistoryId: historyId,
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
            });
            setLoading(false);
            setHistoryInfo(data?.resultData || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        if (loading) {
            getHistoryDetail(currentPage);
        }
    }, [currentPage.page, currentPage.pageSize]);

    const _getStateName = (state) => {
        switch (state) {
            case 'verification':
                return 'Verification Details';
            case 'assignment':
                return 'Assignment Details';
            case 'complete':
                return 'Complete Details';
            case 'other-task':
                return 'Other Task Details';
            case 'cancel-task':
                return 'Cancel Task Details';
            default:
                return 'Other Task Details';
        }
    };

    const _getTagRequest = (nameEn, nameTh) => {
        console.log(nameEn);
        if (nameEn === 'New') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#1890FF', borderColor: '#1890FF' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Verified') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#7B67FB', borderColor: '#7B67FB' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Assigned') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Preparing') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'In Progress') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F9C153', borderColor: '#F9C153' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Done') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Reject') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F0536F', borderColor: '#F0536F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else {
            return <>-</>;
        }
    };

    const _getTagOperationStatus = (nameEn, nameTh) => {
        if (nameEn === 'Doing') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F9C153', borderColor: '#F9C153' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Task Done') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Task Canceled') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F0536F', borderColor: '#F0536F' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'Task Canceling') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else if (nameEn === 'To Do') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#1890FF', borderColor: '#1890FF' }}
                >
                    {lang === 'en' ? nameEn : nameTh}
                </Tag>
            );
        } else {
            return <>-</>;
        }
    };

    const columns = [
        {
            title: <div>{t('Title')}</div>,
            dataIndex: lang === 'en' ? 'titleEn' : 'titleTh',
            key: 'title',
            width: '34%',
        },
        {
            title: <div>{t('OldData')}</div>,
            dataIndex: 'oldValue',
            key: 'oldValue',
            width: '33%',
            render: (_, { oldValue }) => (
                <>
                    {oldValue?.length > 0 ? (
                        oldValue.map((item) => {
                            return <div className="text-gray-600">{item}</div>;
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                </>
            ),
        },
        {
            title: <div>{t('CurrentData')}</div>,
            dataIndex: 'newValue',
            key: 'newValue',
            width: '33%',
            render: (_, { newValue }) => (
                <>
                    {newValue?.length > 0 ? (
                        newValue.map((item) => {
                            return <div className="text-gray-600">{item}</div>;
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                </>
            ),
        },
    ];

    return (
        <div>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        // navigate(`/risk-assessment/${riskId}/view`);
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </div>
                {t('History')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Subject 360')} /{' '}
                </span>
                <span className="text-sm text-gray-400">
                    {t('My Task List')} /{' '}
                </span>
                <span className="text-sm text-gray-400">
                    {_getStateName(state)} /{' '}
                </span>
                <span> {t('History')} </span>
            </div>
            <div className="bg-white rounded-xl p-4 my-4">
                <div className="grid grid-cols-2 p-4">
                    <div className="col-span-1">
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Request ID')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.requestId || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('LogDate')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.logDate
                                    ? moment(historyInfo?.logDate).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Update By')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.updateBy || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('MyTask.Department')} :
                            </div>
                            <div className="col-span-8">
                                {lang === 'en'
                                    ? historyInfo?.departmentName || '-'
                                    : historyInfo?.departmentName || '-'}
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('MyTask.Action')} :
                            </div>
                            <div className="col-span-8">
                                {historyInfo?.action ? (
                                    <Tag
                                        className="rounded-xl -my-1 text-center px-4 text-white"
                                        color="#7B67FB"
                                    >
                                        {i18n.language === 'en'
                                            ? historyInfo?.action
                                            : historyInfo?.action}
                                    </Tag>
                                ) : (
                                    <>-</>
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-10 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('MyTask.RequestStatus')} :
                            </div>
                            <div className="col-span-8">
                                {_getTagRequest(
                                    historyInfo?.requestStatus,
                                    historyInfo?.requestStatus
                                )}
                            </div>
                        </div>
                        <div className="grid grid-cols-10">
                            <div className="col-span-2 font-semibold">
                                {t('MyTask.OperationStatus')} :
                            </div>
                            <div className="col-span-8">
                                {_getTagOperationStatus(
                                    historyInfo?.operationStatus,
                                    historyInfo?.operationStatus
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl p-4">
                <Table
                    bordered
                    className="inbox_table"
                    dataSource={historyInfo?.dsrTaskHistoryDifResponse || []}
                    columns={columns}
                    pagination={false}
                />
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={currentPage?.pageSize}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div>
        </div>
    );
}
